import { render, staticRenderFns } from "./PedidosList.vue?vue&type=template&id=e5609eea"
import script from "./PedidosList.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidosList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports